var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIcTag20 = function SvgIcTag20(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "m17.363 9.297-6.085-6.085A.642.642 0 0 0 10.783 3H3.708C3.283 3 3 3.283 3 3.708v7.075c0 .212.07.354.212.495l6.085 6.085c.425.425.92.637 1.486.637s1.132-.212 1.486-.637l5.094-5.094c.85-.85.85-2.123 0-2.972zm-.99 1.981-5.095 5.095a.684.684 0 0 1-.99 0L4.415 10.5V4.415H10.5l5.873 5.873a.684.684 0 0 1 0 .99zM7.74 6.75a.642.642 0 0 1 .212.495c0 .213-.07.354-.212.496a.642.642 0 0 1-.496.212.642.642 0 0 1-.495-.212c-.07-.071-.142-.142-.142-.213-.07-.07-.07-.212-.07-.283 0-.212.07-.353.212-.495.212-.212.495-.283.778-.142.071 0 .142.071.213.142z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h159v20H0z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#9CC100",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIcTag20);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic-tag-20.9dedef19c0de56453e4f99cbd177dabf.svg";